var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 512,
    height: 512,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,20.003l-2.834-5.669L-.003,11.5l5.669-2.834,2.834-5.669,2.834,5.669,5.669,2.834-5.669,2.834-2.834,5.669ZM2.233,11.5l4.178,2.089,2.089,4.178,2.089-4.178,4.178-2.089-4.178-2.089-2.089-4.178-2.089,4.178-4.178,2.089Zm16.267,12.489l-1.826-3.651-3.651-1.826,3.651-1.825,1.826-3.652,1.826,3.652,3.651,1.825-3.651,1.826-1.826,3.651Zm-3.241-5.477l2.161,1.081,1.08,2.161,1.08-2.161,2.161-1.081-2.161-1.08-1.08-2.161-1.08,2.161-2.161,1.08Zm4.254-9.497l-1.497-2.994-2.993-1.496,2.993-1.497L19.513,.036l1.497,2.994,2.993,1.497-2.993,1.496-1.497,2.994Zm-2.254-4.49l1.503,.751,.751,1.502,.751-1.502,1.503-.751-1.503-.751-.751-1.502-.751,1.502-1.503,.751Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.bb7ba62d16e1c55a817392999cebb257.svg";
export { ForwardRef as ReactComponent };